import { Ajax } from "../Common/Ajax";
import { CookieHelper } from "../Common/CookieHelper";
import { GlobalData } from "../Common/GlobalData";
import { HtmlHelpers } from "../Common/HtmlHelpers";
import { BigPictureHelper, TemplateHelpers } from "../Common/KendoHelpers";

export class AccountsLots {
    private static readonly DETAIL_EACH = 'detailEach';
    private static readonly DETAIL_ALL = 'detailAll';
    private static readonly DETAIL_EACH_ID = '#' + AccountsLots.DETAIL_EACH;
    private static readonly DETAIL_ALL_ID = '#' + AccountsLots.DETAIL_ALL;
    private static readonly GRID = '#grid';

    private static userId: string;

    constructor(userId: string) {
        AccountsLots.userId = userId;
        this.init();
    }

    private init() {
        this.initCookie(AccountsLots.DETAIL_EACH_ID, AccountsLots.DETAIL_EACH);
        this.initCookie(AccountsLots.DETAIL_ALL_ID, AccountsLots.DETAIL_ALL);

        this.initBigPictureHeader();

        let url = GlobalData.URL_BASE +
            GlobalData.URL_SUFFIX_PERSONAL_ACCOUNTS_LOTS;
        if (AccountsLots.userId) {
            url += "/portfolio?userId=" + AccountsLots.userId;
        }

        $(AccountsLots.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: url,
                }
            },
            height: 915,
            groupable: false,
            navigatable: true,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            detailInit: this.openDetail,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '20%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: 'numAccounts',
                    title: 'Acts',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'sumQtyOwn',
                    title: 'Qty',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "costPerShare",
                    title: "Cost/Share",
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                }, 
                {
                    field: "close",
                    title: "Close",
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "marketValue",
                    title: "Market",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "sumCostBasis",
                    title: "CostBasis",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "gainLoss",
                    title: "GainLoss$",
                    width: '9%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getColorCurrencyTemplate('gainLoss')),
                },
                {
                    field: "gainLossPct",
                    title: "GainLoss%",
                    width: '7%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getColorPercentTemplate('gainLossPct')),
                },
                {
                    field: 'account',
                    title: 'Account',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'action',
                    title: 'Action',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
            ]
        });

        this.defineEvents();
    }

    private initCookie(id: string, cookie: string) {
        const checked = CookieHelper.get(cookie);
        if (checked == 'true') {
            const element = $(id).first()[0] as HTMLInputElement;
            element.checked = true;
        }
    }

    private defineEvents() {
        $(AccountsLots.DETAIL_EACH_ID).off().on('change', () => {
            HtmlHelpers.checkboxOnChange(AccountsLots.DETAIL_EACH);
        });

        $(AccountsLots.DETAIL_ALL_ID).off().on('change', () => {
            HtmlHelpers.checkboxOnChange(AccountsLots.DETAIL_ALL);
        });
    }

    private initBigPictureHeader() {
        BigPictureHelper.showBigPictureData();
    }

    private openDetail(e: any) {
        let urlSuffix = GlobalData.URL_SUFFIX_PERSONAL_ACCOUNTS_LOTS +
            '/Detail?symbol=' + e.data.symbol;
        if (AccountsLots.userId) {
            urlSuffix += '&userId=' + AccountsLots.userId;
        }

        const success = (data: any) => {
            if (e.detailCell != null) {
                e.detailCell.html(data);
            }
        };

        const error = (x: any, y: any, z: any) => {
            e.detailCell = null;
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }
}
